export const removeInitialZeros = (value?: string) =>
  String(value).replace(/^0+/, "");
